const EmptyStateIcon = () => (
    <svg width="174" height="174" viewBox="0 0 174 174" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g opacity="0.2" filter="url(#filter0_f_446_7851)">
            <ellipse cx="81" cy="82" rx="60" ry="60" fill="#F7C658" fillOpacity="0.4"/>
        </g>
        <g clipPath="url(#clip0_446_7851)">
            <g filter="url(#filter1_ii_446_7851)">
                <path d="M108.871 73.5076L113.417 63.5076L123.417 58.9621L113.417 54.4167L108.871 44.4167L104.326 54.4167L94.3257 58.9621L104.326 63.5076L108.871 73.5076ZM81.5984 75.3257L72.5075 55.3257L63.4166 75.3257L43.4166 84.4167L63.4166 93.5076L72.5075 113.508L81.5984 93.5076L101.598 84.4167L81.5984 75.3257ZM108.871 95.3257L104.326 105.326L94.3257 109.871L104.326 114.417L108.871 124.417L113.417 114.417L123.417 109.871L113.417 105.326L108.871 95.3257Z" fill="url(#paint0_linear_446_7851)"/>
            </g>
        </g>
        <defs>
            <filter id="filter0_f_446_7851" x="1" y="2" width="160" height="160" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feGaussianBlur stdDeviation="10" result="effect1_foregroundBlur_446_7851"/>
            </filter>
            <filter id="filter1_ii_446_7851" x="42.4166" y="43.4167" width="82" height="82" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dx="-1" dy="1"/>
                <feGaussianBlur stdDeviation="0.5"/>
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                <feColorMatrix type="matrix" values="0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0"/>
                <feBlend mode="normal" in2="shape" result="effect1_innerShadow_446_7851"/>
                <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                <feOffset dx="1" dy="-1"/>
                <feGaussianBlur stdDeviation="0.5"/>
                <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1"/>
                <feColorMatrix type="matrix" values="0 0 0 0 0.729374 0 0 0 0 0.540103 0 0 0 0 0.115208 0 0 0 0.5 0"/>
                <feBlend mode="normal" in2="effect1_innerShadow_446_7851" result="effect2_innerShadow_446_7851"/>
            </filter>
            <linearGradient id="paint0_linear_446_7851" x1="83.4166" y1="44.4167" x2="83.4166" y2="124.417" gradientUnits="userSpaceOnUse">
                <stop stopColor="#FFE5B2"/>
                <stop offset="1" stopColor="#F7C658"/>
            </linearGradient>
            <clipPath id="clip0_446_7851">
                <rect width="82" height="82" fill="white" transform="translate(40 41)"/>
            </clipPath>
        </defs>
    </svg>
);

export default EmptyStateIcon;
